import { memo, useCallback, useContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { OEContext } from '@aytm/app/stats/page/comments'

import { range } from '@aytm/app/stats/page/comments/lib/utils'

import ImageResponse from '@aytm/app/stats/page/comments/image-responses/ImageResponse'

import { Button } from 'primereact/button'

import scrollToElement from 'scroll-to-element'

import style from '@aytm/app/stats/page/comments/styles/index.module.scss'
import { DEFAULT_SELECTED_QUESTION } from '@aytm/app/stats/page/components/lib/constants'

const PageDataImageResponses = memo(
  ({
    reportId,
    responsesOptions,
    showTraitsRef,
    responseOrderRef,
    isFilterDuplicates,
    isShowHiddenFilters,
    currentResponse,
    onCloseNotification,
    onChangeFilterDuplicates,
    onUpdateParams,
    onPageChange
  }) => {
    const { searchState } = useContext(OEContext)

    const { request, totalPages, isLoading, isProcessing, isAdmin } = searchState
    const { selectedQuestion, currentPage } = request

    const [isShowPopup, setIsShowPopup] = useState(null)

    const searchStateRef = useRef()
    searchStateRef.current = searchState

    const currentResponseRef = useRef()
    currentResponseRef.current = currentResponse

    const onKeyDownHandler = useCallback(event => {
      if (27 == event.keyCode) {
        setIsShowPopup(null)
      }
    }, [])

    useEffect(() => {
      window.addEventListener('keydown', onKeyDownHandler)
      return () => {
        window.removeEventListener('keydown', onKeyDownHandler)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      if (!isLoading) return

      scrollToElement('.-header', {
        offset: 0,
        align: 'top',
        duration: 250
      })
    }, [isLoading])

    return (
      <>
        <div className={style['image-responses']}>
          {responsesOptions.pageData && 0 < responsesOptions.pageData.length ? (
            responsesOptions.pageData.map(item => (
              <ImageResponse
                key={`PageDataResponse_${item.response.uid}_${Object.keys(item.answer).join('')}`}
                dataId={`Response_${item.response.uid}_${Object.keys(item.answer).join('')}`}
                reportId={reportId}
                survey={responsesOptions.survey}
                reportVirtual={responsesOptions.reportVirtual}
                reportSchema={responsesOptions.reportSchema}
                response={item}
                showTraitsRef={showTraitsRef}
                responseOrderRef={responseOrderRef}
                isShowHiddenFilters={isShowHiddenFilters}
                isShowPopup={isShowPopup}
                setIsShowPopup={setIsShowPopup}
                onCloseNotification={onCloseNotification}
                onUpdateParams={onUpdateParams}
              />
            ))
          ) : (
            <div className={style['no-results']}>{!isLoading && <>No image responses found</>}</div>
          )}
          {(isLoading || isProcessing) && (
            <div
              className={classNames(style['status-loader'], {
                [style['status-loader-static']]: !responsesOptions.pageData || !responsesOptions.pageData.length
              })}
            >
              <span className={`afd-loader afd-loader-long`}>
                {range(0, 80).map(id => (
                  <span key={`loading-span-${id}`} />
                ))}
              </span>
            </div>
          )}
          <div style={{ width: 170, height: 0 }} />
          <div style={{ width: 170, height: 0 }} />
          <div style={{ width: 170, height: 0 }} />
        </div>
        {!isLoading && !isProcessing ? (
          <>
            <div className={style['image-responses-bottom-paginaton']}>
              <div className={style['left']}>
                {1 < currentPage ? (
                  <Button
                    className="p-button-rounded p-button-blue"
                    label="PREVIOUS PAGE"
                    disabled={isLoading || isProcessing}
                    onClick={isLoading || isProcessing ? null : () => onPageChange(currentPage - 1, null)}
                  />
                ) : null}
              </div>
              <div className={style['right']}>
                {currentPage < totalPages ? (
                  <Button
                    className="p-button-rounded p-button-blue"
                    label="NEXT PAGE"
                    disabled={isLoading || isProcessing}
                    onClick={isLoading || isProcessing ? null : () => onPageChange(currentPage + 1, null)}
                  />
                ) : null}
              </div>
            </div>
          </>
        ) : null}
        <div>
          {isAdmin &&
          !isLoading &&
          !isProcessing &&
          selectedQuestion &&
          selectedQuestion !== DEFAULT_SELECTED_QUESTION ? (
            <div className={style['image-responses-duplicates-toggle']}>
              <span onClick={onChangeFilterDuplicates}>{!isFilterDuplicates ? 'Show' : 'Hide'} duplicates</span>
            </div>
          ) : null}
        </div>
      </>
    )
  }
)

PageDataImageResponses.propTypes = {
  reportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  survey: PropTypes.object,
  responsesOptions: PropTypes.object,
  showTraitsRef: PropTypes.object,
  responseOrderRef: PropTypes.object,
  currentResponse: PropTypes.object,
  isShowHiddenFilters: PropTypes.bool,
  isFilterDuplicates: PropTypes.bool,
  setCurrentResponse: PropTypes.func,
  onCloseNotification: PropTypes.func,
  onUpdateParams: PropTypes.func,
  onPageChange: PropTypes.func,
  onChangeFilterDuplicates: PropTypes.func
}

PageDataImageResponses.displayName = 'PageDataImageResponses'

export default PageDataImageResponses
